module.exports = __webpack_public_path__ + "static/media/1.eff99268.jpeg";